import React, {useEffect, useState} from "react";
import {HomeState} from "./Interfaces/HomeState";
import Category from "../Categories/Category";
import Products from "../Products/Products";
import HomeHeader from "./view/component/HomeHeader";
import {useParams, useSearchParams} from "react-router-dom";
import AppCartController from "../Main/controller/AppCartController";
import ProductError from "./view/component/HomeError";
import {get} from "lodash";
import AppSettingController from "../Main/controller/AppSettingController";

export default function Home() {
    const { shopId } = useParams()

    const [searchParams] = useSearchParams()

    const marketMode = searchParams.get("mode")

    if (marketMode) {
        AppSettingController.setViewModeSetting(marketMode)
    }


    const [state, setState] = useState<HomeState>({
        loading: true,
        error: false,
    })

    useEffect(() => {
        if (shopId)
            AppSettingController.getShopData(shopId).then()

    }, [shopId]);

    useEffect(() => {
        // clear card
        AppCartController.clearCart()
    }, []);


    // error handler
    if (state.error && !state.loading)
        return <ProductError message={get(state, "message", '')}/>

    // if (isMobile)
    //     return (
    //         <InstallGuidePwa/>
    //     )

    return (
        <div>
            <section>
                <HomeHeader/>
                <Category/>
                <Products/>
            </section>
        </div>
    )
}